import { createAction } from '@reduxjs/toolkit';
import { AlertConfig } from './alertTypes';

export const ALERT_ACTION_PREFIX = 'alert-redux/';

export const showAlertInfoAction = createAction<AlertConfig>(`${ALERT_ACTION_PREFIX}show-alert-info`);
export const hideAlertInfoAction = createAction<undefined>(`${ALERT_ACTION_PREFIX}hide-alert-info`);
export const clearAlertInfoAction = createAction<undefined>(`${ALERT_ACTION_PREFIX}clear-alert-info`);
